module.exports = __webpack_public_path__ + "img/team1.d52f7232.jpg";